const operateAttrProps = {
  整体业绩: "salesNum",
  // 素1业绩: 342479,
  // 素2业绩: 0,
  // 素3业绩: 0,
  // 素4业绩: 0,
  素金业绩: "sj",
  素金业绩同比: "sjtb",
  素金业绩环比: "sjhb",
  素金达标率: "sjdb",
  转换业绩: "zhyj",
  "钻石/非素": "zsfs",
  钻石业绩: "zs",
  钻石业绩同比: "zstb",
  钻石业绩环比: "zshb",
  钻石达标率: "zsdb",
  钻石销售件数: "zsSalesNum",
  非素业绩: "fs",
  非素业绩同比: "fstb",
  非素业绩环比: "fshb",
  非素达标率: "fsdb",
};

export default operateAttrProps;
